import React from "react";

export default () => <hr className="hr-sm hr-dashed margin-top-none" />;



// WEBPACK FOOTER //
// ./app/modules/shared/components/DashedSeparator/DashedSeparator.jsx